/**
 * Robot Artist Explorers (6–7) — educator-reviewed focused learning beats.
 * These are presentation plans ONLY; the existing renderer owns answers,
 * phase completion, navigation, screenshots and Swan context.
 * Coherent work may share a beat; no extra pages are hardcoded.
 */
export const ROBOT_ARTIST_EXPLORERS_BEAT_PLANS = {
  "explorers-robot-prelude:explorers-prelude-1": [
    {
      "id": "watch",
      "title": "Open the mysterious art-room case",
      "kind": "story",
      "blockIds": [
        "explorers-story-prelude"
      ]
    },
    {
      "id": "notice",
      "title": "Find one visible clue",
      "kind": "observe",
      "blockIds": [
        "explorers-first-clue"
      ]
    },
    {
      "id": "guess",
      "title": "Make your first detective guess",
      "kind": "predict",
      "blockIds": [
        "explorers-first-theory",
        "explorers-swan-prelude",
        "explorers-prelude-gate"
      ]
    }
  ],
  "explorers-robot-wonder:explorers-wonder-1": [
    {
      "id": "remember",
      "title": "Remember your first idea",
      "kind": "review",
      "blockIds": [
        "explorers-first-idea-again"
      ]
    },
    {
      "id": "reveal",
      "title": "Open the new clue",
      "kind": "inspect",
      "blockIds": [
        "explorers-robot-reveal"
      ]
    },
    {
      "id": "choose",
      "title": "What changed? Choose your mission",
      "kind": "predict",
      "blockIds": [
        "explorers-surprise",
        "explorers-goal",
        "explorers-swan-wonder",
        "explorers-wonder-gate"
      ]
    }
  ],
  "explorers-robot-explore:explorers-explore-1": [
    {
      "id": "inspect",
      "title": "Look at the actual kit pieces",
      "kind": "observe",
      "blockIds": [
        "explorers-explore-story",
        "explorers-parts-gallery"
      ]
    },
    {
      "id": "rotate",
      "title": "Explore the virtual parts in 3D",
      "kind": "inspect",
      "blockIds": [
        "explorers-parts-threejs"
      ]
    },
    {
      "id": "identify",
      "title": "Find three real parts and predict a job",
      "kind": "predict",
      "blockIds": [
        "explorers-found-three",
        "explorers-job-prediction",
        "explorers-swan-parts",
        "explorers-parts-gate"
      ]
    }
  ],
  "explorers-robot-understand:explorers-understand-1": [
    {
      "id": "look",
      "title": "Look for the power path",
      "kind": "observe",
      "blockIds": [
        "explorers-understand-story",
        "explorers-circuit-gallery"
      ]
    },
    {
      "id": "predict",
      "title": "What will the switch and crank do?",
      "kind": "predict",
      "blockIds": [
        "explorers-switch-guess",
        "explorers-wobble-guess"
      ]
    },
    {
      "id": "connect",
      "title": "Put the motion story in order",
      "kind": "model",
      "blockIds": [
        "explorers-motion-sequence",
        "explorers-swan-understand",
        "explorers-understand-gate"
      ]
    }
  ],
  "explorers-robot-apply:explorers-apply-1": [
    {
      "id": "prepare",
      "title": "Get ready to build safely",
      "kind": "safety",
      "blockIds": [
        "explorers-apply-safety"
      ]
    },
    {
      "id": "guide",
      "title": "Follow the 3D build guide",
      "kind": "inspect",
      "blockIds": [
        "explorers-assembly-pwo"
      ]
    },
    {
      "id": "check",
      "title": "Check your real robot with a grown-up",
      "kind": "safety",
      "blockIds": [
        "explorers-build-check"
      ]
    }
  ],
  "explorers-robot-apply:explorers-apply-2": [
    {
      "id": "predict",
      "title": "Predict your first drawing",
      "kind": "predict",
      "blockIds": [
        "explorers-first-prediction"
      ]
    },
    {
      "id": "test",
      "title": "Try it, then record what really happened",
      "kind": "record",
      "blockIds": [
        "explorers-first-test",
        "explorers-swan-build",
        "explorers-apply-gate"
      ]
    }
  ],
  "explorers-robot-test-improve:explorers-test-improve-1": [
    {
      "id": "lookback",
      "title": "Review what your robot actually did",
      "kind": "review",
      "blockIds": [
        "explorers-first-test-summary"
      ]
    },
    {
      "id": "change",
      "title": "Choose one safe change and predict",
      "kind": "predict",
      "blockIds": [
        "explorers-one-change",
        "explorers-second-prediction"
      ]
    }
  ],
  "explorers-robot-test-improve:explorers-test-improve-2": [
    {
      "id": "test",
      "title": "Try your changed robot",
      "kind": "record",
      "blockIds": [
        "explorers-second-test"
      ]
    },
    {
      "id": "compare",
      "title": "Compare the two drawings",
      "kind": "explain",
      "blockIds": [
        "explorers-drawing-comparison",
        "explorers-swan-compare",
        "explorers-test-improve-gate"
      ]
    }
  ],
  "explorers-robot-explain:explorers-explain-1": [
    {
      "id": "look",
      "title": "Look again at the robot system",
      "kind": "observe",
      "blockIds": [
        "explorers-explain-gallery"
      ]
    },
    {
      "id": "order",
      "title": "Tell the motion story in order",
      "kind": "model",
      "blockIds": [
        "explorers-explain-chain"
      ]
    },
    {
      "id": "evidence",
      "title": "Point to evidence from your test",
      "kind": "explain",
      "blockIds": [
        "explorers-evidence-point",
        "explorers-swan-explain",
        "explorers-explain-gate"
      ]
    }
  ],
  "explorers-robot-reflect:explorers-reflect-1": [
    {
      "id": "remember",
      "title": "Remember your clue and your tests",
      "kind": "review",
      "blockIds": [
        "explorers-original-clue",
        "explorers-test-summary"
      ]
    },
    {
      "id": "change",
      "title": "How did your first idea change?",
      "kind": "explain",
      "blockIds": [
        "explorers-reflection-choice"
      ]
    },
    {
      "id": "discover",
      "title": "What evidence helped you learn?",
      "kind": "explain",
      "blockIds": [
        "explorers-reflection-evidence",
        "explorers-swan-reflect",
        "explorers-reflect-gate"
      ]
    }
  ],
  "explorers-robot-grow:explorers-grow-1": [
    {
      "id": "name",
      "title": "Name your robot artist",
      "kind": "create",
      "blockIds": [
        "explorers-gallery-image",
        "explorers-name"
      ]
    },
    {
      "id": "choose",
      "title": "Choose a drawing to share",
      "kind": "review",
      "blockIds": [
        "explorers-gallery-pick"
      ]
    },
    {
      "id": "share",
      "title": "Tell someone what you discovered",
      "kind": "explain",
      "blockIds": [
        "explorers-gallery-discovery",
        "explorers-swan-grow",
        "explorers-grow-gate"
      ]
    }
  ]
};
